
    <template>
      <section class="relax-doc">
        <h1>Icon 图标</h1>
<blockquote>
<p>语义化的矢量图形</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>直接通过设置类名为 <code>x-icon-iconName</code> 来使用即可。例如：</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-icon type=&quot;x-icon-star-on&quot;&gt;&lt;/x-icon&gt;
  &lt;x-icon type=&quot;x-icon-link&quot;&gt;&lt;/x-icon&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="tu-biao-ji-he"><a class="header-anchor" href="#tu-biao-ji-he"></a> 图标集合</h2>
<blockquote>
<p>内置了许多的图标</p>
</blockquote>
<x-row class="icon-list">
  <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-heart-on"></i>
    <span class="icon-name">x-icon-heart-on</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-star-on"></i>
    <span class="icon-name">x-icon-star-on</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-sliders"></i>
    <span class="icon-name">x-icon-sliders</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-gitlab"></i>
    <span class="icon-name">x-icon-gitlab</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-maximize"></i>
    <span class="icon-name">x-icon-maximize</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-minimize"></i>
    <span class="icon-name">x-icon-minimize</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-wifi-off"></i>
    <span class="icon-name">x-icon-wifi-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-tv"></i>
    <span class="icon-name">x-icon-tv</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-shopping-cart"></i>
    <span class="icon-name">x-icon-shopping-cart</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-paperclip"></i>
    <span class="icon-name">x-icon-paperclip</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-help-circle"></i>
    <span class="icon-name">x-icon-help-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-crop"></i>
    <span class="icon-name">x-icon-crop</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bold"></i>
    <span class="icon-name">x-icon-bold</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-italic"></i>
    <span class="icon-name">x-icon-italic</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-underline"></i>
    <span class="icon-name">x-icon-underline</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-headphones"></i>
    <span class="icon-name">x-icon-headphones</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-hash"></i>
    <span class="icon-name">x-icon-hash</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud"></i>
    <span class="icon-name">x-icon-cloud</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-command"></i>
    <span class="icon-name">x-icon-command</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-zoom-out"></i>
    <span class="icon-name">x-icon-zoom-out</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-zoom-in"></i>
    <span class="icon-name">x-icon-zoom-in</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-zap"></i>
    <span class="icon-name">x-icon-zap</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-x-circle"></i>
    <span class="icon-name">x-icon-x-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-x"></i>
    <span class="icon-name">x-icon-x</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-wind"></i>
    <span class="icon-name">x-icon-wind</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-x-square"></i>
    <span class="icon-name">x-icon-x-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-wifi"></i>
    <span class="icon-name">x-icon-wifi</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-watch"></i>
    <span class="icon-name">x-icon-watch</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-volume"></i>
    <span class="icon-name">x-icon-volume</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-volume-1"></i>
    <span class="icon-name">x-icon-volume-1</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-volume-2"></i>
    <span class="icon-name">x-icon-volume-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-volume-x"></i>
    <span class="icon-name">x-icon-volume-x</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-voicemail"></i>
    <span class="icon-name">x-icon-voicemail</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-video"></i>
    <span class="icon-name">x-icon-video</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-video-off"></i>
    <span class="icon-name">x-icon-video-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-users"></i>
    <span class="icon-name">x-icon-users</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-user"></i>
    <span class="icon-name">x-icon-user</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-user-x"></i>
    <span class="icon-name">x-icon-user-x</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-user-plus"></i>
    <span class="icon-name">x-icon-user-plus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-user-minus"></i>
    <span class="icon-name">x-icon-user-minus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-user-check"></i>
    <span class="icon-name">x-icon-user-check</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-unlock"></i>
    <span class="icon-name">x-icon-unlock</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-upload-cloud"></i>
    <span class="icon-name">x-icon-upload-cloud</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-umbrella"></i>
    <span class="icon-name">x-icon-umbrella</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-upload"></i>
    <span class="icon-name">x-icon-upload</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-twitter"></i>
    <span class="icon-name">x-icon-twitter</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-type"></i>
    <span class="icon-name">x-icon-type</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-triangle"></i>
    <span class="icon-name">x-icon-triangle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-trash"></i>
    <span class="icon-name">x-icon-trash</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-trash-2"></i>
    <span class="icon-name">x-icon-trash-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-toggle-right"></i>
    <span class="icon-name">x-icon-toggle-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-toggle-left"></i>
    <span class="icon-name">x-icon-toggle-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-thumbs-down"></i>
    <span class="icon-name">x-icon-thumbs-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-thumbs-up"></i>
    <span class="icon-name">x-icon-thumbs-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-thermometer"></i>
    <span class="icon-name">x-icon-thermometer</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-target"></i>
    <span class="icon-name">x-icon-target</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-sunset"></i>
    <span class="icon-name">x-icon-sunset</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-tag"></i>
    <span class="icon-name">x-icon-tag</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-tablet"></i>
    <span class="icon-name">x-icon-tablet</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-sunrise"></i>
    <span class="icon-name">x-icon-sunrise</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-sun"></i>
    <span class="icon-name">x-icon-sun</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-stop-circle"></i>
    <span class="icon-name">x-icon-stop-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-star"></i>
    <span class="icon-name">x-icon-star</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-speaker"></i>
    <span class="icon-name">x-icon-speaker</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-square"></i>
    <span class="icon-name">x-icon-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-smartphone"></i>
    <span class="icon-name">x-icon-smartphone</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-slash"></i>
    <span class="icon-name">x-icon-slash</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-slack"></i>
    <span class="icon-name">x-icon-slack</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-skip-forward"></i>
    <span class="icon-name">x-icon-skip-forward</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-sidebar"></i>
    <span class="icon-name">x-icon-sidebar</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-shuffle"></i>
    <span class="icon-name">x-icon-shuffle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-skip-back"></i>
    <span class="icon-name">x-icon-skip-back</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-settings"></i>
    <span class="icon-name">x-icon-settings</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-shield"></i>
    <span class="icon-name">x-icon-shield</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-share"></i>
    <span class="icon-name">x-icon-share</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-share-2"></i>
    <span class="icon-name">x-icon-share-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-scissors"></i>
    <span class="icon-name">x-icon-scissors</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-server"></i>
    <span class="icon-name">x-icon-server</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-search"></i>
    <span class="icon-name">x-icon-search</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-save"></i>
    <span class="icon-name">x-icon-save</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-rotate-cw"></i>
    <span class="icon-name">x-icon-rotate-cw</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-refresh-cw"></i>
    <span class="icon-name">x-icon-refresh-cw</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-rotate-ccw"></i>
    <span class="icon-name">x-icon-rotate-ccw</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-rewind"></i>
    <span class="icon-name">x-icon-rewind</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-refresh-ccw"></i>
    <span class="icon-name">x-icon-refresh-ccw</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-repeat"></i>
    <span class="icon-name">x-icon-repeat</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-radio"></i>
    <span class="icon-name">x-icon-radio</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-power"></i>
    <span class="icon-name">x-icon-power</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-printer"></i>
    <span class="icon-name">x-icon-printer</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-pocket"></i>
    <span class="icon-name">x-icon-pocket</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-plus"></i>
    <span class="icon-name">x-icon-plus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-plus-circle"></i>
    <span class="icon-name">x-icon-plus-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-plus-square"></i>
    <span class="icon-name">x-icon-plus-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-play"></i>
    <span class="icon-name">x-icon-play</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-play-circle"></i>
    <span class="icon-name">x-icon-play-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-pie-chart"></i>
    <span class="icon-name">x-icon-pie-chart</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-outgoing"></i>
    <span class="icon-name">x-icon-phone-outgoing</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone"></i>
    <span class="icon-name">x-icon-phone</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-incoming"></i>
    <span class="icon-name">x-icon-phone-incoming</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-off"></i>
    <span class="icon-name">x-icon-phone-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-missed"></i>
    <span class="icon-name">x-icon-phone-missed</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-forwarded"></i>
    <span class="icon-name">x-icon-phone-forwarded</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-phone-call"></i>
    <span class="icon-name">x-icon-phone-call</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-percent"></i>
    <span class="icon-name">x-icon-percent</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-pause"></i>
    <span class="icon-name">x-icon-pause</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-pause-circle"></i>
    <span class="icon-name">x-icon-pause-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-package"></i>
    <span class="icon-name">x-icon-package</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-octagon"></i>
    <span class="icon-name">x-icon-octagon</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-navigation"></i>
    <span class="icon-name">x-icon-navigation</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-navigation-2"></i>
    <span class="icon-name">x-icon-navigation-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-music"></i>
    <span class="icon-name">x-icon-music</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-move"></i>
    <span class="icon-name">x-icon-move</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-more-horizontal"></i>
    <span class="icon-name">x-icon-more-horizontal</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-more-vertical"></i>
    <span class="icon-name">x-icon-more-vertical</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-monitor"></i>
    <span class="icon-name">x-icon-monitor</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-moon"></i>
    <span class="icon-name">x-icon-moon</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-minus"></i>
    <span class="icon-name">x-icon-minus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-minus-square"></i>
    <span class="icon-name">x-icon-minus-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-mic"></i>
    <span class="icon-name">x-icon-mic</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-minus-circle"></i>
    <span class="icon-name">x-icon-minus-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-mic-off"></i>
    <span class="icon-name">x-icon-mic-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-minimize-2"></i>
    <span class="icon-name">x-icon-minimize-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-message-square"></i>
    <span class="icon-name">x-icon-message-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-message-circle"></i>
    <span class="icon-name">x-icon-message-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-menu"></i>
    <span class="icon-name">x-icon-menu</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-map-pin"></i>
    <span class="icon-name">x-icon-map-pin</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-map"></i>
    <span class="icon-name">x-icon-map</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-maximize-2"></i>
    <span class="icon-name">x-icon-maximize-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-mail"></i>
    <span class="icon-name">x-icon-mail</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-loader"></i>
    <span class="icon-name">x-icon-loader</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-log-out"></i>
    <span class="icon-name">x-icon-log-out</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-lock"></i>
    <span class="icon-name">x-icon-lock</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-list"></i>
    <span class="icon-name">x-icon-list</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-log-in"></i>
    <span class="icon-name">x-icon-log-in</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-link"></i>
    <span class="icon-name">x-icon-link</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-life-buoy"></i>
    <span class="icon-name">x-icon-life-buoy</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-link-2"></i>
    <span class="icon-name">x-icon-link-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-layout"></i>
    <span class="icon-name">x-icon-layout</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-instagram"></i>
    <span class="icon-name">x-icon-instagram</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-info"></i>
    <span class="icon-name">x-icon-info</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-layers"></i>
    <span class="icon-name">x-icon-layers</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-inbox"></i>
    <span class="icon-name">x-icon-inbox</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-image"></i>
    <span class="icon-name">x-icon-image</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-github"></i>
    <span class="icon-name">x-icon-github</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-home"></i>
    <span class="icon-name">x-icon-home</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-heart"></i>
    <span class="icon-name">x-icon-heart</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-grid"></i>
    <span class="icon-name">x-icon-grid</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-globe"></i>
    <span class="icon-name">x-icon-globe</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-flag"></i>
    <span class="icon-name">x-icon-flag</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-filter"></i>
    <span class="icon-name">x-icon-filter</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-folder"></i>
    <span class="icon-name">x-icon-folder</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-file-plus"></i>
    <span class="icon-name">x-icon-file-plus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-file"></i>
    <span class="icon-name">x-icon-file</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-film"></i>
    <span class="icon-name">x-icon-film</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-file-text"></i>
    <span class="icon-name">x-icon-file-text</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-fast-forward"></i>
    <span class="icon-name">x-icon-fast-forward</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-eye-off"></i>
    <span class="icon-name">x-icon-eye-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-file-minus"></i>
    <span class="icon-name">x-icon-file-minus</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-facebook"></i>
    <span class="icon-name">x-icon-facebook</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-feather"></i>
    <span class="icon-name">x-icon-feather</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-eye"></i>
    <span class="icon-name">x-icon-eye</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-external-link"></i>
    <span class="icon-name">x-icon-external-link</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-edit-1"></i>
    <span class="icon-name">x-icon-edit-1</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-edit"></i>
    <span class="icon-name">x-icon-edit</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-edit-2"></i>
    <span class="icon-name">x-icon-edit-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-droplet"></i>
    <span class="icon-name">x-icon-droplet</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-download"></i>
    <span class="icon-name">x-icon-download</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-download-cloud"></i>
    <span class="icon-name">x-icon-download-cloud</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-delete"></i>
    <span class="icon-name">x-icon-delete</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-disc"></i>
    <span class="icon-name">x-icon-disc</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-crosshair"></i>
    <span class="icon-name">x-icon-crosshair</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-credit-card"></i>
    <span class="icon-name">x-icon-credit-card</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cpu"></i>
    <span class="icon-name">x-icon-cpu</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-right-up"></i>
    <span class="icon-name">x-icon-corner-right-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-right-down"></i>
    <span class="icon-name">x-icon-corner-right-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-up-right"></i>
    <span class="icon-name">x-icon-corner-up-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-up-left"></i>
    <span class="icon-name">x-icon-corner-up-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-left-up"></i>
    <span class="icon-name">x-icon-corner-left-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-left-down"></i>
    <span class="icon-name">x-icon-corner-left-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-down-left"></i>
    <span class="icon-name">x-icon-corner-down-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-corner-down-right"></i>
    <span class="icon-name">x-icon-corner-down-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-copy"></i>
    <span class="icon-name">x-icon-copy</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-compass"></i>
    <span class="icon-name">x-icon-compass</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud-snow"></i>
    <span class="icon-name">x-icon-cloud-snow</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-codepen"></i>
    <span class="icon-name">x-icon-codepen</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud-off"></i>
    <span class="icon-name">x-icon-cloud-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud-rain"></i>
    <span class="icon-name">x-icon-cloud-rain</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud-drizzle"></i>
    <span class="icon-name">x-icon-cloud-drizzle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cloud-lightning"></i>
    <span class="icon-name">x-icon-cloud-lightning</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-clock"></i>
    <span class="icon-name">x-icon-clock</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chrome"></i>
    <span class="icon-name">x-icon-chrome</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-clipboard"></i>
    <span class="icon-name">x-icon-clipboard</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-circle"></i>
    <span class="icon-name">x-icon-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevrons-left"></i>
    <span class="icon-name">x-icon-chevrons-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevrons-up"></i>
    <span class="icon-name">x-icon-chevrons-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevrons-right"></i>
    <span class="icon-name">x-icon-chevrons-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevrons-down"></i>
    <span class="icon-name">x-icon-chevrons-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevron-up"></i>
    <span class="icon-name">x-icon-chevron-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevron-right"></i>
    <span class="icon-name">x-icon-chevron-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevron-left"></i>
    <span class="icon-name">x-icon-chevron-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-chevron-down"></i>
    <span class="icon-name">x-icon-chevron-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-cast"></i>
    <span class="icon-name">x-icon-cast</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-check-square"></i>
    <span class="icon-name">x-icon-check-square</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-check"></i>
    <span class="icon-name">x-icon-check</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-check-circle"></i>
    <span class="icon-name">x-icon-check-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-camera"></i>
    <span class="icon-name">x-icon-camera</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-box"></i>
    <span class="icon-name">x-icon-box</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bookmark"></i>
    <span class="icon-name">x-icon-bookmark</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-calendar"></i>
    <span class="icon-name">x-icon-calendar</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-camera-off"></i>
    <span class="icon-name">x-icon-camera-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-briefcase"></i>
    <span class="icon-name">x-icon-briefcase</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-book"></i>
    <span class="icon-name">x-icon-book</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bell"></i>
    <span class="icon-name">x-icon-bell</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bluetooth"></i>
    <span class="icon-name">x-icon-bluetooth</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-battery"></i>
    <span class="icon-name">x-icon-battery</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bell-off"></i>
    <span class="icon-name">x-icon-bell-off</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-battery-charging"></i>
    <span class="icon-name">x-icon-battery-charging</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bar-chart-2"></i>
    <span class="icon-name">x-icon-bar-chart-2</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-bar-chart"></i>
    <span class="icon-name">x-icon-bar-chart</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-award"></i>
    <span class="icon-name">x-icon-award</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-up"></i>
    <span class="icon-name">x-icon-arrow-up</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-up-right"></i>
    <span class="icon-name">x-icon-arrow-up-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-up-left"></i>
    <span class="icon-name">x-icon-arrow-up-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-down"></i>
    <span class="icon-name">x-icon-arrow-down</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-right"></i>
    <span class="icon-name">x-icon-arrow-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-left"></i>
    <span class="icon-name">x-icon-arrow-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-aperture"></i>
    <span class="icon-name">x-icon-aperture</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-anchor"></i>
    <span class="icon-name">x-icon-anchor</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-down-right"></i>
    <span class="icon-name">x-icon-arrow-down-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-arrow-down-left"></i>
    <span class="icon-name">x-icon-arrow-down-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-align-right"></i>
    <span class="icon-name">x-icon-align-right</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-align-left"></i>
    <span class="icon-name">x-icon-align-left</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-align-justify"></i>
    <span class="icon-name">x-icon-align-justify</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-airplay"></i>
    <span class="icon-name">x-icon-airplay</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-align-center"></i>
    <span class="icon-name">x-icon-align-center</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-alert-triangle"></i>
    <span class="icon-name">x-icon-alert-triangle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-activity"></i>
    <span class="icon-name">x-icon-activity</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-alert-circle"></i>
    <span class="icon-name">x-icon-alert-circle</span>
   </x-col>
   <x-col :xs="24" :sm="12" :md="8" :lg="4">
    <i class="x-icon-alert-octagon"></i>
    <span class="icon-name">x-icon-alert-octagon</span>
   </x-col>
</x-row>

      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_icon = _resolveComponent("x-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_icon, { type: "x-icon-star-on" }),
    _createVNode(_component_x_icon, { type: "x-icon-link" })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  